import React from 'react';
import GenericError from './GenericError';

export const Unauthorized = () => {
  return (
    <GenericError
      title={'401: Unauthorized'}
      description={`You don't have permissions to access this application.`}
      imgSrc={`/static/images/undraw_close_tab_uk6g.svg`}
    />
  );
};

export default Unauthorized;
